import React from 'react';
import { Show, SimpleShowLayout, TextField } from 'react-admin';
import BooleanIntegerField from '../../fields/BooleanIntegerField';

const PlanShow = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="duration_months" />
      <TextField source="price" />
      <BooleanIntegerField source="payment" />
      <TextField source="duration_days" />
      <TextField source="max_coaches" />
    </SimpleShowLayout>
  </Show>
);

export default PlanShow;



// WEBPACK FOOTER //
// ./src/resources/plans/PlanShow.jsx